import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import * as Helpers from "./helpers";
import * as Config from "./helpers/Configuracao";
import store from "./store/index";
import "typeface-roboto/index.css";
import fullscreen from "vue-fullscreen";
import Vuelidate from "vuelidate";
import vueNumeral from "vue-numeral-filter";
import VueCurrencyInput from "vue-currency-input";
import VueApexCharts from "vue-apexcharts";
import money from "vuejs-money";
import PortalVue from "portal-vue";
import './style/index.css'
import '@/components/webcotacao/styles/webcotacao.css'
import sysDataTable from "./components/utils/dataTable/sysDataTable/Index.vue"
import SysBtn from "./components/utils/SysBtn.vue"

import ParametrizacaoLayout from "@/components/Parametrizacao/Includes/LayoutParametrizacao.vue";
import SystockLayout from "@/components/layout/SystockLayout";

Vue.component('parametrizacao-layout', ParametrizacaoLayout);
Vue.component('systock-layout', SystockLayout);

Vue.use(vueNumeral, { locale: "pt-br" });
Vue.use(fullscreen);
Vue.use(Vuelidate);
Vue.use(VueCurrencyInput);
Vue.use(VueApexCharts);
Vue.use(money);
Vue.use(PortalVue);

Vue.component("apexchart", VueApexCharts);
Vue.component('sys-data-table', sysDataTable);
Vue.component('SysBtn', SysBtn);

Vue.config.productionTip = false;

Vue.prototype.Helpers = Helpers;
Vue.prototype.Config = Config;

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
